import { Address } from './Address'

export class DeliveryDetails {
    constructor(
        public emailAddress: string | null,
        public name: string | null,
        public postalDeliveryAddress: Address | null,
    ) { }

    get isPostalDelivery(): boolean {
        return this.postalDeliveryAddress !== null
    }
}
